import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Subtile Fade-In-Transition beim Route-Wechsel.
 *
 * Hintergrund: `tailwindcss-animate` triggert `animate-in`-Klassen nur beim
 * ersten Mount eines Knoten. Wir verwenden den Location-Pathname als React-`key`,
 * sodass beim Route-Wechsel der innere Sub-Tree remounted wird und die Animation
 * neu startet. Sehr leichter Effekt — Power-User merken ihn kaum, neue Nutzer
 * empfinden den UI als ruhiger und weniger "harsch".
 *
 * `prefers-reduced-motion: reduce` setzt die Animation global auf 1 ms (siehe
 * styles.css) — keine Sonderbehandlung hier noetig.
 */
export function RouteTransition({ children }: { children: ReactNode }): JSX.Element {
  const location = useLocation();
  return (
    <div
      key={location.pathname}
      className="animate-in fade-in slide-in-from-bottom-1 duration-base ease-spring"
    >
      {children}
    </div>
  );
}
